/**
 * The endpoint the occupants feature talks to: the portal's own
 * `contract-contacts` resource, a plain `apiResource` — index, store, update
 * and destroy. There is no atomic-operations route here, so a write that spans
 * several rows is several requests.
 */
export const CONTRACT_CONTACTS_ENDPOINT = "/folloportal/contract-contacts";

/** The person behind the subscriptions. `contract-contacts` only ever attaches
 * a contact that already exists (`contact_id` is required and checked against
 * the contract), so creating one is its own request. */
export const CONTACTS_ENDPOINT = "/folloportal/contacts";

export const RESOURCE_TYPE = "contract-contacts";

/** A contact has at most one row per alert type, and the endpoint paginates
 * rows rather than contacts — so a contact's rows would straddle a page
 * boundary. One contract's subscriptions are fetched whole and grouped
 * client-side instead. */
export const CONTRACT_CONTACTS_PER_PAGE = 100;
